export function matchesObject(left, right) {
  return (
    Boolean(left?.object_id && right?.object_id) &&
    ['account_id', 'object_type', 'object_id'].every(
      (key) => String(left[key]) === String(right[key])
    )
  )
}

export function acceptsObjectWrite(event, frameWindow, origin, object) {
  return (
    event.source === frameWindow &&
    event.origin === origin &&
    event.data?.purpose === 'coach_object_write' &&
    matchesObject(object, event.data)
  )
}

export function currentHeaderObject(doc = document) {
  const headers = [
    ...doc.querySelectorAll('[data-admin--header-coach-object-value]'),
  ]
  return headers
    .map((header) => {
      try {
        return JSON.parse(
          header.getAttribute('data-admin--header-coach-object-value')
        )
      } catch {
        return null
      }
    })
    .filter((object) => object?.object_id)
    .at(-1)
}

// Preserve microseconds while normalizing older markers written in the actor's timezone.
export function objectWriteTimestamp(at) {
  const time = Date.parse(at)
  if (typeof at !== 'string' || !Number.isFinite(time)) return null
  const fraction = (at.match(/\.(\d+)/)?.[1] || '').padEnd(6, '0').slice(0, 6)
  return new Date(time).toISOString().replace(/\.\d{3}Z$/, `.${fraction}Z`)
}
